export default "__VITE_ASSET__CUW$yE4q__"